<template>
  <v-card flat tile class="border-light-grey mt-4">
    <v-card-title class="headline grey lighten-4">
      <v-layout>
        <v-flex class="text-right">
          <v-btn
            :disabled="pageLoading"
            :loading="pageLoading"
            class="white--text mr-2"
            depressed
            color="blue darken-4"
            tile
            v-on:click="openDialog"
          >
            Add Machine Type
          </v-btn>
          <!-- <v-btn :disabled="pageLoading" :loading="pageLoading" class="white--text mr-2" depressed
                        color="blue darken-4" tile v-on:click="openSubDialog">
                        Add Machine-Model
                    </v-btn> -->
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-progress-linear
      indeterminate
      height="6"
      v-if="pageLoading"
      class="position-absolute"
      color="blue darken-4"
    ></v-progress-linear>
    <v-card-text class="p-6">
      <v-row>
        <v-col md="2" class="py-0">
          <!-- <TextInput clearable hide-details :disabled="pageLoading" :loading="pageLoading" id="category-search"
                        placeholder="Search " v-model="search" v-on:click:clear="getDepartments()"
                        v-on:keydown:esc="getDepartments()" v-on:keydown:enter="getDepartments()"
                        v-on:keydown:tab="getDepartments()">
                    </TextInput> -->
          <v-text-field
            v-model.trim="search"
            v-on:click:clear="getDepartments('search')"
            clearable
            dense
            filled
            flat
            label="Search"
            hide-details
            solo
            :disabled="pageLoading"
            color="cyan"
            @keydown.enter="getDepartments"
            @keydown.tab="getDepartments"
          ></v-text-field>
        </v-col>
      </v-row>
       <template v-if="pageLoading">
        <h3
          class="custom-header-blue-text font-size-18 m-0 text-uppercase px-2"
          style="line-height: 64px !important"
        >
          <v-skeleton-loader
            class="my-5"
            type="heading"
          ></v-skeleton-loader>
        </h3>
        <v-simple-table
          class="table-bordered"
          fixed-header
          dense
          height="calc(100vh - 200px)"
        >
          <template v-slot:default>
            <thead>
              <tr v-for="i in 10" :key="i">
                <td class="simple-table-th font-size-16" width="100">
                  <v-skeleton-loader
                    class="custom-skeleton py-2 my-0"
                    type="text"
                  ></v-skeleton-loader>
                </td>
                <td class="simple-table-th font-size-16">
                  <v-skeleton-loader
                    class="py-2 my-0"
                    type="sentences"
                  ></v-skeleton-loader>
                </td>
              </tr>
            </thead>
          </template>
        </v-simple-table>
      </template>
      <v-simple-table class="bt-table mt-4" v-else>
        <template v-slot:default>
          <thead>
            <tr>
              <th width="50" class="simple-table-th">Action</th>
              <th class="simple-table-th">Machine Type</th>
              <th width="200" class="simple-table-th">Created At</th>
              <th width="200" class="simple-table-th">Last Modified At</th>
            </tr>
          </thead>

          <tbody v-if="departmentCategory?.length">
            <tr
              class="cursor-pointer"
              v-for="(cat, ind) in departmentCategory"
              :key="ind"
              v-on:click="updateCategory(cat)"
            >
              <td width="100" class="simple-table-td">
                <v-tooltip top content-class="custom-top-tooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      fab
                      dark
                      x-small
                      color="green"
                      v-bind="attrs"
                      v-on="on"
                      class="mr-1 ml-2"
                      v-on:click="updateVoucher(cat)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
              </td>
              <td width="300" class="simple-table-td pl-4">{{ cat.name }}</td>

              <td width="200" class="simple-table-td pl-4">
                {{ cat.added_at }}
              </td>
              <td width="200" class="simple-table-td pl-4">
                <template v-if="cat.updated_at">{{ cat.updated_at }}</template>
                <em class="text--secondary" v-else>no updated at</em>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4" class="simple-table-td">
                <p class="m-0 text-center">
                  <img
                    width="30"
                    :src="$assetURL('media/error/empty.png')"
                    class="row-not-found-image mr-4"
                  />
                  Uhh... There are no machine types at the moment.
                </p>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <ListingFooter
        v-if="departmentCategory?.length"
        :dataLoading="pageLoading"
        :showingFrom="showingFrom"
        :showingTo="showingTo"
        :totalRows="total"
        :currentPage="currentPage"
        :totalPages="totalPages"
        removePage
      ></ListingFooter>
      <!-- <v-layout v-if="departmentCategory?.length" class="light-border-top mt-4">
                <v-flex md6>
                    <label class="btx-label p-4">Showing {{ showingFrom }} to {{ showingTo }} of {{ total }} entries</label>
                </v-flex>
                <v-flex md6>
                    <v-pagination color="blue darken-4" v-model="currentPage" :length="totalPages"
                        total-visible="7"></v-pagination>
                </v-flex>
            </v-layout> -->
    </v-card-text>
    <Dialog :dialog="dialog">
      <template v-slot:title>
        <v-layout>
          <v-flex>Machine Types </v-flex>
          <v-flex class="text-right">
            <v-btn
              :disabled="pageLoading"
              :loading="pageLoading"
              class="white--text"
              depressed
              color="blue darken-4"
              tile
              v-on:click="addCategory()"
            >
              <v-icon left>mdi-plus</v-icon>
              Add...
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <template v-slot:body>
        <v-container fluid class="pt-0">
          <template v-for="(row, ind) in categories">
            <TextInput
              :key="ind"
              hide-details
              :disabled="pageLoading"
              :loading="pageLoading"
              :id="`category-${ind}`"
              v-on:keypress="(e) => manageLimit(e, ind)"
              v-on:paste="(e) => onPaste(e, ind)"
              placeholder="Machine type"
              v-model="row.name"
              :append-outer-icon="categories?.length > 1 ? `mdi-delete` : ''"
              class=""
              v-on:click:append-outer="removeCategory(ind)"
            ></TextInput>
          </template>
        </v-container>
      </template>
      <template v-slot:action>
        <v-btn
          :disabled="pageLoading"
          :loading="pageLoading"
          class="white--text mr-2"
          depressed
          color="blue darken-4"
          tile
          v-on:click="updateCategories()"
        >
          Save
        </v-btn>
        <v-btn
          :disabled="pageLoading"
          depressed
          tile
          v-on:click="dialog = false"
        >
          Cancel
        </v-btn>
      </template>
    </Dialog>
    <Dialog :dialog="editdialog">
      <template v-slot:title>
        <v-layout>
          <v-flex>Edit Machine Type</v-flex>
        </v-layout>
      </template>
      <template v-slot:body>
        <v-container fluid class="pt-0">
          <template>
            <TextInput
              hide-details
              :disabled="pageLoading"
              :loading="pageLoading"
              :id="`category-${deptcategory.id}`"
              v-on:keypress="(e) => manageLimits(e)"
              v-on:paste="(e) => onPastes(e)"
              placeholder="Machine type"
              v-model="deptcategory.name"
            ></TextInput>
          </template>
        </v-container>
      </template>
      <template v-slot:action>
        <v-btn
          :disabled="pageLoading"
          :loading="pageLoading"
          class="white--text mr-2"
          depressed
          color="blue darken-4"
          tile
          v-on:click="updateDeptCategories()"
        >
          Save
        </v-btn>
        <v-btn
          :disabled="pageLoading"
          depressed
          tile
          v-on:click="editdialog = false"
        >
          Cancel
        </v-btn>
      </template>
    </Dialog>
    <Dialog dense :dialog="subCategoryDialog">
      <template v-slot:title>
        {{ dialogTitle }}
      </template>
      <template v-slot:body>
        <v-container fluid class="pt-0">
          <v-form
            ref="voucherForm"
            v-model.trim="formValid"
            lazy-validation
            v-on:submit.stop.prevent="updateOrCreate()"
          >
            <v-row>
              <v-col md="12">
                <v-layout>
                  <v-flex md4 class="my-auto">
                    <label for="voucher-name" class="btx-label mt-2 required">
                      Machine Type</label
                    >
                  </v-flex>
                  <v-flex md8>
                    <AutoCompleteInput
                      hide-details
                      :hideTopMargin="true"
                      :class="{ required: !voucher.department }"
                      :items="departmentCategory"
                      id="segment"
                      item-text="name"
                      style="width: 500px"
                      item-value="id"
                      v-model="voucher.department"
                      placeholder="Machine Type"
                    >
                    </AutoCompleteInput>
                    <!-- <TextInput
                                            hide-details
                                        
                                            :class="{ required: !voucher.name }"
                                            v-model="voucher.name"
                                            :disabled="pageLoading"
                                            :loading="pageLoading"
                                            id="voucher-name"
                                            placeholder="Voucher Name"
                                        ></TextInput> -->
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex md4 class="my-auto">
                    <label for="voucher-name" class="btx-label mt-2 required">
                      Name</label
                    >
                  </v-flex>
                  <v-flex md8>
                    <template v-for="(row, ind) in sub_categories">
                      <div class="d-flex align-center" :key="ind">
                        <TextInput
                          hide-details
                          :disabled="pageLoading"
                          :loading="pageLoading"
                          :id="`voucher-${ind}`"
                          v-on:keypress="(e) => manageLimitSub(e, ind)"
                          v-on:paste="(e) => onPasteSub(e, ind)"
                          placeholder="Department category"
                          v-model="row.name"
                          v-on:click:append-outer="addSubCategory(ind)"
                          class="has-delete-outer"
                        ></TextInput>

                        <v-btn
                          v-if="sub_categories.length > 1"
                          class="mx-1 mt-3"
                          :id="`voucher-${ind}`"
                          v-on:click="removSubCategory(ind)"
                          fab
                          dark
                          x-small
                          color="red"
                        >
                          <v-icon dark> mdi-minus </v-icon>
                        </v-btn>

                        <v-btn
                          class="mx-1 mt-3"
                          fab
                          dark
                          :id="`voucher-${ind}`"
                          v-on:click="addSubCategory(ind)"
                          x-small
                          color="primary"
                        >
                          <v-icon dark> mdi-plus </v-icon>
                        </v-btn>
                      </div>
                    </template>
                  </v-flex>
                </v-layout>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </template>
      <template v-slot:action>
        <v-btn
          :disabled="pageLoading || !formValid"
          :loading="pageLoading"
          class="white--text mr-2"
          depressed
          color="blue darken-4"
          tile
          v-on:click="updateOrCreate()"
        >
          Save
        </v-btn>
        <v-btn
          :disabled="pageLoading"
          depressed
          tile
          v-on:click="subCategoryDialog = false"
        >
          Cancel
        </v-btn>
      </template>
    </Dialog>

    <DeleteTemplate
      type="voucher"
      :delete-text="deleteText"
      delete-note="All transactions of this voucher will also be deleted."
      :delete-dialog="deleteDialog"
      :delete-endpoint="deleteEndpoint"
      v-on:close="deleteDialog = false"
      v-on:delete:success="getDepartments"
    >
    </DeleteTemplate>
  </v-card>
</template>

<script>
import { toSafeInteger } from "lodash";

//   import SettingHeader from "@/view/components/SettingHeader";
import { QUERY } from "@/core/services/store/request.module";
import AutoCompleteInput from "@/view/components/AutoCompleteInput";
import TextInput from "@/view/components/TextInput";
import DeleteTemplate from "@/view/components/DeleteTemplate";

import Dialog from "@/view/components/Dialog";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  UPDATE_MACHINE_TYPES,
  CREATE_MACHINE_MODELS,
  UPDATE_MACHINE_TYPE,
} from "@/core/lib/common.lib";
import { SET_ERROR, SET_MESSAGE } from "@/core/services/store/common.module";
// import SubCategoryTemplate from "@/view/module/setting/SubCategoryTemplate";
import { RefressBus } from "@/core/event-bus/refress.bus.js";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import { PaginationEventBus } from "@/core/lib/pagination.lib";

export default {
  props: {
    // title: {
    //     type: Object,
    //     default: () => {
    //         return [];
    //     },
    // },
  },
  data() {
    return {
      search: null,
      selectstatus: null,
      currentPage: 1,
      pageLimit: 1,
      showingFrom: 0,
      showingTo: 0,
      totalRows: 0,
      deleteDialog: false,
      deleteEndpoint: null,
      deleteText: null,
      dialogTitle: "Add Machine Type Model",
      subCategory: [],
      departmentCategory: [],
      dialog: false,
      editdialog: false,
      dataLoading: false,
      formValid: false,
      subCategoryDialog: false,
      voucher: {
        name: null,
        department: null,
      },
      deptcategory: {
        name: null,
        id: null,
      },
      pageLoading: false,
      category: 0,
      categoryName: null,
      categories: [{ name: null }],
      sub_categories: [{ name: null }],
    };
  },
  methods: {
    onPasteSub(e, index) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.sub_categories[index].name;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 29) {
        let trimValue = finalval.substring(0, 30);
        this.sub_categories[index].name = trimValue;
        e.preventDefault();
      }
    },
    manageLimitSub(e, index) {
      if (
        this.sub_categories[index].name &&
        this.sub_categories[index].name.length > 29
      ) {
        e.preventDefault();
      }
    },

    onPaste(e, index) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.categories[index].name;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 29) {
        let trimValue = finalval.substring(0, 30);
        this.categories[index].name = trimValue;
        e.preventDefault();
      }
    },

    manageLimit(e, index) {
      if (
        this.categories[index].name &&
        this.categories[index].name.length > 29
      ) {
        e.preventDefault();
      }
    },
    manageLimits(e) {
      if (this.deptcategory.name && this.deptcategory.name.length > 29) {
        e.preventDefault();
      }
    },
    onPastes(e) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.deptcategory.name;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 29) {
        let trimValue = finalval.substring(0, 30);
        this.deptcategory.name = trimValue;
        e.preventDefault();
      }
    },

    updateVoucher(row) {
      this.subCategoryDialog = false;
      console.log(row, "row");

      this.deptcategory.id = row?.id;
      this.deptcategory.name = row?.name;
    },

    openDialog() {
      this.categories = [{ name: null }];
      this.dialog = true;
    },
    openSubDialog() {
      this.sub_categories = [{ name: null }];
      this.voucher.department = 0;
      this.subCategoryDialog = true;
    },
    clearVars() {
      this.subCategoryDialog = false;
    },
    updateCategory({ id, name }) {
      this.category = id;
      this.categoryName = name;
      this.editdialog = true;
    },
    addCategory() {
      this.categories.push({
        name: null,
      });
    },
    addSubCategory() {
      this.sub_categories.push({
        name: null,
      });
    },
    removSubCategory(index) {
      this.sub_categories.splice(index, 1);
      if (this.sub_categories.length <= 0) {
        this.addSubCategory();
      }
    },
    removeCategory(index) {
      this.categories.splice(index, 1);
      if (this.categories.length <= 0) {
        this.addCategory();
      }
    },
    getDepartments(search = "") {
      if (search == "") {
        this.search = "";
      }
      const _this = this;
      _this.pageLoading = true;
      this.$store
        .dispatch(QUERY, {
          url: `department-categorys-type`,
          data: {
            search: this.selectstatus,
            current_page: this.currentPage,
            filter: this.search,
          },
        })
        .then((data) => {
          this.sub_categories = [{ name: null }];
          _this.departmentCategory = data?.data?.rows;
          this.currentPage = data?.data?.current_page;
          this.showingFrom = data?.data?.showingFrom;
          this.showingTo = data?.data?.showingTo;
          this.total = data?.data?.totalrows;
          this.totalPages = data?.data?.totalPages;

          this.addCategory();
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.timerLoading = false;
          _this.pageLoading = false;
          _this.dialog = false;
          _this.editdialog = false;
          _this.subCategoryDialog = false;
          _this.voucher.department = 0;
        });
    },
    async updateDeptCategories() {
      const _this = this;
      try {
        _this.pageLoading = true;

        //   for (let i = 0; i < this.categories.length; i++) {
        //     // if (this.categories && this.categories[i] && this.categories[i].file) {
        //     // 	formData.append(`file[${i}][file]`, this.categories[i].file);
        //     // }
        //     if (this.categories && this.categories[i] && !this.categories[i].name) {
        //       _this.$store.commit(SET_ERROR, [{ model: true, message: 'This field is required' }]);
        //       return false;

        //     }
        //   }

        //console.log(_this.deptcategory, 'params')
        await UPDATE_MACHINE_TYPE(_this.deptcategory);
        _this.getDepartments();
        _this.dialog = false;
        _this.$store.commit(SET_MESSAGE, [
          { model: true, message: "Machine Type Updated Successfully" },
        ]);
      } catch (error) {
        _this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
      } finally {
        _this.pageLoading = false;
      }
    },

    async updateCategories() {
      //console.log('shs');
      const _this = this;
      try {
        _this.pageLoading = true;

        for (let i = 0; i < this.categories.length; i++) {
          if (
            this.categories &&
            this.categories[i] &&
            !this.categories[i].name
          ) {
            _this.$store.commit(SET_ERROR, [
              { model: true, message: "This field is required" },
            ]);
            return false;
          }
        }
        await UPDATE_MACHINE_TYPES({ options: _this.categories });
        _this.getDepartments();
        _this.dialog = false;
        _this.$store.commit(SET_MESSAGE, [
          { model: true, message: "Department Category created Successfully" },
        ]);
      } catch (error) {
        _this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
      } finally {
        _this.pageLoading = false;
      }
    },
    async updateOrCreate() {
      const _this = this;

      if (!_this.$refs.voucherForm.validate()) {
        return false;
      }
      console.log(this.voucher.department);
      console.log(_this.sub_categories, "vouvher");

      try {
        _this.pageLoading = true;
        if (_this.voucherId) {
          await CREATE_MACHINE_MODELS(_this.voucherId, _this.voucher);
          _this.clearVars();
          _this.$store.commit(SET_MESSAGE, [
            { model: true, message: "Updated Successfully." },
          ]);
        } else {
          await CREATE_MACHINE_MODELS(_this.voucher?.department, {
            options: _this.sub_categories,
          });
          (_this.sub_categories = [{ name: null }]),
            // _this.voucher?.department=null,
            _this.getDepartments();
          _this.clearVars();

          _this.$store.commit(SET_MESSAGE, [
            { model: true, message: "Sub-Department Created Successfully." },
          ]);
        }
      } catch (error) {
        _this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
      } finally {
        _this.pageLoading = false;
        RefressBus.$emit("data:update", true);
      }
    },
  },
  watch: {
    currentPage() {
     /*  this.getDepartments(); */
    },
  },

  mounted() {
    //console.log(this.title);
    this.getDepartments();
    if (this.$route.query && this.$route.query.tab) {
      this.productTab = this.$route.query.tab;
    } else {
      this.$router.replace({
        query: { tab: "categories", t: new Date().getTime() },
      });
    }
    PaginationEventBus.$on("update:pagination", (param) => {
      this.currentPage = param;
      /* this.getDepartments(); */
    });
    RefressBus.$on("data:update", (argument) => {
      if (argument) {
        this.getDepartments();
      }
    });
  },

  // this.$store.dispatch(SET_BREADCRUMB, [
  //   { text: "Setting", disabled: true },
  //   { text: "Categories", disabled: true },
  // ]);

  beforeDestroy() {
    this.$store.dispatch(SET_BREADCRUMB, []);
  },
  components: {
    Dialog,
    TextInput,
    // SubCategoryTemplate,
    //   SettingHeader,
    AutoCompleteInput,
    DeleteTemplate,
    ListingFooter,
  },
  computed: {
    dialogWidth() {
      return toSafeInteger((document.body.clientWidth / 100) * 70);
    },
  },
};
</script>
<style>
.mdi-delete::before {
  color: red;
}
</style>
